import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useErrorContext } from '../../components/messages/ErrorBox';
import { usePageLoadingContext } from '../../components/messages/PageLoading';
import { useLocale } from '../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from '../../components/special/apiCall';
import RowButtons from '../../components/button/RowButtons';
import RowChangeButton from '../../components/button/RowChangeButton';
import ListTable from '../../components/form/ListTable';
import ListHeader from 'components/form/ListHeader';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const LabelsList = ({ }) => {
  const [list1, setList1] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState(null);

  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  const loadList = async () => {
    const data = await apiGetCall(BASE_URL + '/admin/list/labels');
    if (isResultOk(data, setListError, true)) {
     // console.log("labels data", data);
      setList1(data);
    }
    setListLoading(false);
  }

  useEffect(() => {
    loadList();
  }, []);



  return (
    <div>
      <ListHeader title={t("Merkingar")} />
      <div>
        <div className="text-right"><Link to="/admin/labels/edit?newkey=true" className="no-print button gray-light icon-plus pointer-edit text-14">{t("Skrá nýja Merkingu")}</Link></div>
        <ListTable
          error={listError}
          isLoading={listLoading}
          list={list1}
          colsettings={['25%', '25%', '20%','10%']}
          headers={[
            t("Merking"),
            t("Tegund Merkingar"),
            t("Virkt"),
            ""
          ]}
          columns={[
            (item) => <>{item.name}</>,
            (item) => <>{item.labelTypeName}</>,
            (item) => <>{item.isEnabled ? "Já" : "Nei"} </>,
            (item) => (<RowButtons>
              <RowChangeButton link={"/admin/labels/edit?labelid=" + item.labelId} />
            </RowButtons>),
          ]}

        />
      </div>
    </div>

  );
};

